const translations = {
  ENG: {
    CASE_DETAILS: "Case details",
    CASE_ID: "Case ID",
    CASE_TITLE: "Case Title",
    CASE_SUBMITTED_DATE: "Case Submitted Date",
    CASE_STATUS: "Case Status",
    REQUEST_WITHDRAW: "Request to withdraw",
    CASE_PROGRESS: "Case progress",
    REQUESTED_EVIDENCE: "Requested Evidence",
    SEE: "See",
    VICTIM_SUPPORT_DIRECTORY: "Victim support directory",
    ORGANIZATION: "Organization",

    // 🔹 Stepper Text
    UNDER_REVIEW: "Under Review",
    ASSIGNED: "Assigned",
    IN_PROGRESS: "In Progress",
    COMPLETE: "Complete",

    // login page
    PHONE_NUMBER_TITLE: "Phone number",
    EMAIL_TITLE: "Email",
    PHONE_SUBTEXT: "Use the mobile number you used to submit your case to log in.",
    EMAIL_SUBTEXT: "Use the email you used to submit your case to log in.",
    LOGIN_USING: "Log in using",
    EMAIL: "Email",
    MOBILE_NUMBER: "Mobile Number",
    CASE_ID_REQUIRED: "Case ID is required",
    REPORT_CASE: "Report case",
    WANT_TO_REPORT: "Want to address a new case?",
    CONTINUE: "Continue",
    TRY_AGAIN_LATER: "Something went wrong. Please try again in a few minutes.",

    // otp confirmation
    OTP_TITLE: "OTP",
    OTP_DESC: "Input the one time password (OTP) received to your mobile",
    OTP_LABEL: "OTP",
    OTP_REQUIRED: "This field is required",
    RESEND_OTP: "Re-send the OTP",

    // request
    REQUEST_HEADER:'Are you sure do you want to withdraw the case?',
    REQUEST_CONF:'Please provide the reason to withdraw the case',
    REMARK:'Remark (optional)',
    CANCEL:'Cancel',
    REQUEST:'Request',
    UPLOAD_HEADER:'Are you sure do you want to withdraw the case?',

    // Uploader
    UPLOAD_HEADER: 'Please upload requested evidence related to the incident',
    MASSAGE:'Message',
    REQUESTED_DOCUMENTS:'Requested evidence types',
    UPLOAD:'Upload',
    UPLOAD_POPUP_HEADER:'Evidence request',
    CLICK_TO_UPLOAD:'Click to upload',
    REQUESTED_DATE:'Requested date',

    CHATS:'Chats',
    NO_CHATS:'No chats available',
    SELECT_CHAT:'Select Chat',
    NO_MESSAGES:'No messages yet',
    TYPE_MESSAGE:'Type a message...',
    SEND:'Send'
  },

  SIN: {
    CASE_DETAILS: "විනිශ්චය විස්තර",
    CASE_ID: "විනිශ්චය අංකය",
    CASE_TITLE: "ශීර්ෂය",
    CASE_SUBMITTED_DATE: "ඉදිරිපත් කළ දිනය",
    CASE_STATUS: "විසදුම් තත්ත්වය",
    REQUEST_WITHDRAW: "ඉවත් කිරීමට ඉල්ලුම් කරන්න",
    CASE_PROGRESS: "ප්‍රගති",
    REQUESTED_EVIDENCE: "ඉල්ලුම් කළ සාක්ෂි",
    SEE: "බලන්න",
    VICTIM_SUPPORT_DIRECTORY: "පීඩිත සහාය නාමාවලිය",
    ORGANIZATION: "විවිධාංගනය",

    // 🔹 Stepper Text
    UNDER_REVIEW: "සමාලෝචනයට යටත්ව ඇත",
    ASSIGNED: "පවරා ඇත",
    IN_PROGRESS: "ක්‍රියාවලිය කටයුතු කරමින්",
    COMPLETE: "සම්පූර්ණයි",

    // login page
    PHONE_NUMBER_TITLE: "දුරකථන අංකය",
    EMAIL_TITLE: "ඊමේල්",
    PHONE_SUBTEXT: "ඔබේ නඩුව ඉදිරිපත් කිරීමේදී භාවිත කළ දුරකථන අංකය ඇතුලත් කර ලොග් වන්න.",
    EMAIL_SUBTEXT: "ඔබේ නඩුව ඉදිරිපත් කිරීමේදී භාවිත කළ ඊමේල් ලිපිනය ඇතුලත් කර ලොග් වන්න.",
    LOGIN_USING: "පිවිසෙන්න",
    EMAIL: "ඊමේල්",
    MOBILE_NUMBER: "ජංගම දුරකථන අංකය",
    CASE_ID_REQUIRED: "නඩු අංකය අවශ්‍ය වේ",
    REPORT_CASE: "නඩුවක් සටහන් කරන්න",
    WANT_TO_REPORT: "නව නඩුවක් සටහන් කිරීමට අවශ්‍යද?",
    CONTINUE: "තහවුරු කරන්න",
    TRY_AGAIN_LATER: "දෝෂයක් සිදු විය. කරුණාකර මිනිත්තු කිහිපයකින් නැවත උත්සාහ කරන්න.",

    // otp confirmation
    OTP_TITLE: "වෙලාවත් පරිපාලන සඟලය (OTP)",
    OTP_DESC: "ඔබගේ ජංගම දුරකථනයට ලැබුණු එක් වරක් භාවිත කළ හැකි රහස් සංඛ්‍යාව (OTP) ඇතුල් කරන්න",
    OTP_LABEL: "OTP",
    OTP_REQUIRED: "මෙම ක්ෂේත්‍රය අවශ්‍ය වේ",
    RESEND_OTP: "OTP නැවත යවන්න",

    // request
    REQUEST_HEADER:'ඔබට විශ්වාසද, ඔබට මෙම ගොණුව නීති මණ්ඩලයෙන් ආපසු ගන්න අවශ්‍යද?',
    REQUEST_CONF:'කරුණාකර නඩුව ප්‍රතිහරනය කිරීමට හේතුව ලබා දෙන්න',
    REMARK:'සටහන (විකල්ප)',
    CANCEL:'අවලංගු කරන්න',
    REQUEST:'ඉල්ලීම',

    // Uploader
    UPLOAD_HEADER: 'කාරණාවට සංබන්ධිත ලෙස ඉල්ලූ සාක්ෂි උඩුගත කරන්න.',
    MASSAGE:'පණිවිඩය',
    REQUESTED_DOCUMENTS:'ඉල්ලූ සාක්ෂි වර්ග',
    UPLOAD:'උඩුගත කරන්න',
    UPLOAD_POPUP_HEADER:'සාක්ෂි ඉල්ලීම',
    CLICK_TO_UPLOAD:'උඩුගත කිරීමට ක්ලික් කරන්න',
    REQUESTED_DATE:'ඉල්ලීම් කළ දිනය',

    CHATS: 'චැට්',
    NO_CHATS: 'චැට් නොමැත',
    SELECT_CHAT: 'චැට් එකක් තෝරන්න',
    NO_MESSAGES: 'පණිවිඩ නොමැත',
    TYPE_MESSAGE: 'පණිවිඩයක් ලියන්න...',
    SEND: 'යවන්න'
  },

  TAM: {
    CASE_DETAILS: "வழக்கு விவரங்கள்",
    CASE_ID: "வழக்கு ஐடி",
    CASE_TITLE: "தலைப்பு",
    CASE_SUBMITTED_DATE: "சமர்ப்பித்த தேதி",
    CASE_STATUS: "நிலை",
    REQUEST_WITHDRAW: "திரும்ப பெற கோருக",
    CASE_PROGRESS: "முன்னேற்றம்",
    REQUESTED_EVIDENCE: "கோரிய சான்றுகள்",
    SEE: "பார்",
    VICTIM_SUPPORT_DIRECTORY: "பாதிக்கப்பட்டோர் ஆதரவு அடைவு",
    ORGANIZATION: "நிறுவனம்",

    // 🔹 Stepper Text
    UNDER_REVIEW: "பரிசீலனையில் உள்ளது",
    ASSIGNED: "ஒதுக்கப்பட்டுள்ளது",
    IN_PROGRESS: "முன்னேற்றத்தில் உள்ளது",
    COMPLETE: "முடிக்கப்பட்டது",

    // login page
    PHONE_NUMBER_TITLE: "தொலைபேசி எண்",
    EMAIL_TITLE: "மின்னஞ்சல்",
    PHONE_SUBTEXT: "உங்கள் வழக்கை சமர்ப்பித்தபோது பயன்படுத்திய தொலைபேசி எண்ணை உள்ளிடவும்.",
    EMAIL_SUBTEXT: "உங்கள் வழக்கை சமர்ப்பித்தபோது பயன்படுத்திய மின்னஞ்சலை உள்ளிடவும்.",
    LOGIN_USING: "இதன் மூலம் உள்நுழைக",
    EMAIL: "மின்னஞ்சல்",
    MOBILE_NUMBER: "மொபைல் எண்",
    CASE_ID_REQUIRED: "வழக்கு ஐடி தேவை",
    REPORT_CASE: "வழக்கை அறிவிக்கவும்",
    WANT_TO_REPORT: "புதிய வழக்கை பதிவு செய்ய வேண்டுமா?",
    CONTINUE: "தொடரவும்",
    TRY_AGAIN_LATER: "பிழை ஏற்பட்டது. சில நிமிடங்களில் மீண்டும் முயற்சிக்கவும்.",

    // otp confirmation
    OTP_TITLE: "OTP",
    OTP_DESC: "உங்கள் மொபைலுக்கு வந்த ஒருமுறை கடவுச்சொல்லை (OTP) உள்ளிடவும்",
    OTP_LABEL: "OTP",
    OTP_REQUIRED: "இந்த புலம் அவசியம்",
    RESEND_OTP: "OTP ஐ மறுபடியும் அனுப்பு",

    // request
    REQUEST_HEADER:'நீங்கள் நிச்சயமாக வழக்கை திரும்பப் பெற விரும்புகிறீர்களா?',
    REQUEST_CONF:'வழக்கை வாபஸ் பெற காரணத்தை வழங்கவும்.',
    REMARK:'குறிப்பு (விருப்பமானது)',
    CANCEL:'ரத்து செய்யவும்',
    REQUEST:'கோரிக்கை',

    // Uploader
    UPLOAD_HEADER: 'நிகழ்வுடன் தொடர்புடைய கோரப்பட்ட சான்றுகளை பதிவேற்றவும்.',
    MASSAGE:'செய்தி',
    REQUESTED_DOCUMENTS:'கோரப்பட்ட சான்று வகைகள்',
    UPLOAD:'பதிவேற்றவும்',
    UPLOAD_POPUP_HEADER:'சான்று கோரிக்கை',
    CLICK_TO_UPLOAD:'பதிவேற்றத்தற்கு கிளிக் செய்யவும்',
    REQUESTED_DATE:'கோரிக்கை செய்யப்பட்ட தேதி',

    CHATS: 'அரட்டைகள்',
    NO_CHATS: 'அரட்டைகள் இல்லை',
    SELECT_CHAT: 'ஒரு அரட்டையைத் தேர்வு செய்யவும்',
    NO_MESSAGES: 'செய்திகள் இல்லை',
    TYPE_MESSAGE: 'ஒரு செய்தியை தட்டச்சு செய்யவும்...',
    SEND: 'அனுப்பு'
  },
};

export default translations;
